import { StoreState } from "store/index";

export const getVisible = (state: StoreState) => state.loadingScreen.visible;
